import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { COLOR_BLACK, COLOR_GREYSCALE_BLACK_75 } from "~/theme/colors";
import { getFormatMedia } from "~/theme/utils";

import { DESKTOP_GLOBAL_NAVIGATION_CLASSES } from "./constants";

export interface UseStylesProps {
  offset: number;
  infoBannerOffset: number;
  isInfoBannerClosed?: boolean;
  categoriesRowOffset: number;
  scrollTop: number;
  isInfoBanner?: boolean;
}

export const DesktopGlobalNavigationContainer = styled(Box)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);

  return {
    position: "relative",
    paddingTop: theme.spacing(1.75),
    [`& .${DESKTOP_GLOBAL_NAVIGATION_CLASSES.row}`]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      "& > *:not(:last-of-type)": {
        marginRight: theme.spacing(4),
      },
    },
    [`& .${DESKTOP_GLOBAL_NAVIGATION_CLASSES.floor}`]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),

      [formatMedia.BREAKPOINT_WIDE_DESKTOP]: {
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
      },
    },
    [`& .${DESKTOP_GLOBAL_NAVIGATION_CLASSES.item}`]: {
      color: COLOR_GREYSCALE_BLACK_75,
      padding: `${theme.spacing(1.5)} 0`,
      position: "relative",

      "&.selected, &:active": {
        color: COLOR_BLACK,
      },
      "&::before": {
        content: "''",
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderColor: "transparent",
      },
      "&:hover::before": {
        borderColor: COLOR_GREYSCALE_BLACK_75,
      },
      "&:active::before": {
        borderColor: COLOR_BLACK,
      },
    },
    [`& .${DESKTOP_GLOBAL_NAVIGATION_CLASSES.categoryItem}`]: {
      fontFamily: theme.typography.fontFamily,
      fontSize: 16,
      fontWeight: theme.typography.fontWeightRegular as number,
      lineHeight: "24px",
      letterSpacing: "0.03em",
      textTransform: "uppercase",

      "&.rootLink": {
        ...theme.typography.button,
      },
    },
    [`& .${DESKTOP_GLOBAL_NAVIGATION_CLASSES.hidden}`]: {
      display: "none",
    },
  };
});
